export default {
  storyBreadCrumb:
    'breadcrumbContainer border-t-1 border-greyLine border-solid mt-30',
  contentSections:
    'banner-section banner banner-bottom-shadow collection-page-shadow story-banner relative text-white mb-30',
  breadcrumbContainer:
    'breadcrumbContainer border-t-1 border-lightGrey border-solid pt-15',
  imageWrapper: 'imageWrapper relative z-1',
  titleWrapper: 'titleWrapper',
  heroImageTitle:
    'font-BornreadyRegular text-white lg:text-black text-36 lg:text-56 leading-50 lg:leading-80 tracking-wider7x collection-title-subhead',
  howToStartedAll:
    'font-BebasNeueBold text-white lg:text-white text-36 lg:text-56 leading-tight lg:leading-100 tracking-wider7x howToStartedAll md:mt-150  sm:pl-55 sm:pr-15 md:px-0 lg:w-innerContainer mx-auto',
  viewsTitleWrapper:
    'lg:max-w-container lg:w-full mx-auto absolute left-0 right-0 sm:px-15 z-2 lg:px-15 bottom-0 mb-40 views-title-wrapper',
  powerOfHairStyle:
    'font-BebasNeueBold text-white lg:text-white text-36 lg:text-56 leading-tight lg:leading-100 tracking-wider7x howToStartedAll md:mt-150  sm:pl-55 sm:pr-15 md:pl-70 lg:px-0  lg:w-innerContainer mx-auto',
  moreCollections: {
    mainWrapper:
      'more-collections-section mainWrapper lg:max-w-container mx-auto sm:pl-20 sm:pr-20 sm:pt-40 lg:pt-50 lg:pb-50',
    headingWrapper: 'headingWrapper text-32 lg:text-36 font-BornreadyRegular',
    heading:
      'heading leading-45 font-hairline lg:w-5/6 mx-auto mb-45 text-center',
    hairAdvisor: 'fixed bottom-0 right-0 mr-10 mb-0 z-4',
    breadCrumb: 'breadCrumb',
  },
  UnidasPelosCachos: 'headingMobUnidas',
  ingredient: {
    viewAllButtonWrapper:
      'viewAllButtonWrapper lg:w-innerContainer mx-auto px-20 mt-20 lg:mt-60 font-BebasNeueRegular text-18 leading-30 tracking-wider text-center',
    viewAllButton:
      'viewAllButton font-BebasNeueRegular text-22 leading-30 tracking-wider text-center gradient-line',
    viewAllButtonh4: 'font-normal',
    allIngredients: 'text-18 md:text-16 leading-28 text-black text-left font-HelveticaNeueLight tracking-normal pt-30 discover-button',
  }
};
